// extracted by mini-css-extract-plugin
module.exports = {"section_header":"styles_section_header__f39FI","section_description":"styles_section_description__hBWL0"};